/*
 * Service Finder
 */
import { kcTabs } from './tabs';

export function serviceFinderInit() {
    let tabContainer = document.querySelector('.kc-tabs__tabs');

    if ( tabContainer === null ) {
        return;  // only activate when tabs present
    }
    else {
        // initialise the tabs
        kcTabs();

        // make the tabContainer as wide as the children, including margins
        setParentWidth( tabContainer );

        window.addEventListener('resize', function() {
            setParentWidth( tabContainer );
        });
    }

    // put the active tab on the screen
    var draggable = document.querySelector('.draggable'),
        activeTab = tabContainer.querySelector('.is-active');

    if (!activeTab) {
        activeTab = tabContainer.querySelector('.kc-tabs__tab-link');
        activeTab.click();
    }

    var activeItem = activeTab.parentElement;

    // move the active tab into view
    function activeTabIntoView() {
        tabContainer.classList.remove('js-is-complete');

        if ( activeItem.isSameNode( tabContainer.firstElementChild ) ) {
            // active item is the first item
            tabContainer.classList.add('js-is-complete');
            draggable.scrollLeft = 0;
        }
        else if ( activeItem.offsetLeft == 0 ) {
            // wait for parent width to update
            window.requestAnimationFrame(activeTabIntoView);
        }
        else {
            tabContainer.classList.add('js-is-complete');
            draggable.scrollLeft = activeItem.offsetLeft;
        }
    }

    activeTabIntoView();

    window.addEventListener('resize', function() {
        activeTabIntoView();
    });

};


function setParentWidth( parent ) {
    let children = parent.children,
        width = 0;

    for ( let i = 0; i < children.length; i++ ) {
        let child = children[i],
            marginLeft = parseInt( getComputedStyle(child).marginLeft ) || 0,
            marginRight = parseInt( getComputedStyle(child).marginRight ) || 0;

        width += child.clientWidth + marginLeft + marginRight;
    }

    width += 2;  // give ourselves a little leeway (I blame Bootstrap 3)
    parent.style.width = `${width}px`;
}



// WEBPACK FOOTER //
// ./src/js/service-finder.js